import React, { useState } from 'react';
import { Tabs, Tab, Box, Grid, Typography, Button } from '@mui/material';
import MainCard from "../../components/cards/MainCard";
import { useTheme } from "@mui/material/styles";
import { getCardColor } from "../../utils/colorUtils";
import { BRAND_TYPE } from "../../config";
import ThemeSettings from "./ThemeSettings";
import EmailSettings from "./EmailSettings";
import ReportedSimEmailSettings from "./ReportedSimEmailSettings";
import LandingPageSettings from "./LandingPageSettings";
import { useGetFeatureSwitchesQuery } from "../../store/services/tenancy.service";
import { useSelector } from "react-redux";

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`reports-tabpanel-${index}`}
            aria-labelledby={`reports-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `reports-tab-${index}`,
        'aria-controls': `reports-tabpanel-${index}`,
    };
}

export default function Branding({ data }) {
    const [subTabValue, setSubTabValue] = useState(0);
    const theme = useTheme();
    const lightMode = theme.palette.mode === "light";

    // Get tenancy ID and feature switches
    const { tenancyId } = useSelector((state) => state.tenancy);
    const { data: featureSwitchesApiData } = useGetFeatureSwitchesQuery({ tenancyId });
    const featureSwitches = featureSwitchesApiData?.data || featureSwitchesApiData;

    // Define all possible tabs with their feature flags
    const allTabs = [
        {
            label: "Theme",
            component: <ThemeSettings data={data} />,
            featureFlag: 'enableBrandingTheme'
        },
        {
            label: "Course Emails",
            component: <EmailSettings data={data} />,
            featureFlag: 'enableBrandingEmails'
        },
        {
            label: "Phish Report Integration",
            component: <ReportedSimEmailSettings data={data} />,
            featureFlag: 'enableBrandingReportedSimEmails'
        },
        {
            label: "Landing Page",
            component: <LandingPageSettings data={data} />,
            featureFlag: 'enableBrandingLandingPage'
        }
    ];

    // Filter tabs based on feature switches
    const visibleTabs = allTabs.filter(tab => {
        return !tab.featureFlag || (featureSwitches && featureSwitches[tab.featureFlag]);
    });

    const handleSubTabChange = (event, newValue) => {
        setSubTabValue(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={subTabValue} onChange={handleSubTabChange} aria-label="branding tabs">
                    {visibleTabs.map((tab, index) => (
                        <Tab key={index} label={tab.label} {...a11yProps(index)} />
                    ))}
                </Tabs>
            </Box>
            {visibleTabs.map((tab, index) => (
                <TabPanel key={index} value={subTabValue} index={index}>
                    {tab.component}
                </TabPanel>
            ))}
        </Box>
    );
}